import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { initWebVitals } from "./lib/webVitals";
import { applyStoredColorTheme } from "./components/ColorThemeSwitcher";

applyStoredColorTheme();

createRoot(document.getElementById("root")!).render(<App />);

initWebVitals();

